import React from 'react';
import { ATCONSTANTS as ATC } from 'appconstants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/pro-solid-svg-icons';
import { FasPlus, FasArrowRight } from 'assets/icons';

function CenterSection({ onAdd, isAddingRows }) {
  return (
    <div className="col-1 mr-4 align-center align-self-center">
      <button
        data-id={`${ATC.PACKETID}ADD${ATC.BUTTON}`}
        type="button"
        onClick={onAdd}
        className="btn turquoise whiteSpace-nowrap"
      >
        {isAddingRows ? <FontAwesomeIcon icon={faSpinner} spin className="mr-1" /> : null}
        <FasPlus className="mr-1" />
        Add
        <FasArrowRight className="ml-2" />
      </button>
    </div>
  );
}

export default CenterSection;
